import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { Cookies } from 'react-cookie';
import axios from 'axios';
import { attachApiErrorToastInterceptor } from '../utils/api-error-toast';
export const axiosIns = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosIns);
axiosIns.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.baseURL = process.env.REACT_APP_API_BASE_MENUITEM_URL;
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const menuItemIdService = async (params: any) => {
  try {
    const response = await axiosIns.get(`${params}`);
    return response.data;
  } catch (error: any) {
    toast.error(error.message);
    return Promise.reject(error);
  }
};
export const useMenuItemIdService = (params: any) => {
  return useQuery({
    queryKey: ['menuitemid-service', params],
    queryFn: () => menuItemIdService(params),
  });
};

export const menuItemRestuarentService = async ({ restuarentId, pageParam, catParam, itemParam, nameParam }: any) => {
  try {
    const response = await axiosIns.get(`/restaurant/${restuarentId}`, {
      params: {
        page_number: pageParam,
        category_id: catParam,
        items_per_page: itemParam,
        name: nameParam,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useRestaurantMenuItem = (
  detailId: string | undefined,
  currentCat: number | null,
  itemsPerPage: number,
  inputValue: string,
) => {
  return useInfiniteQuery({
    queryKey: ['menu-item', detailId, currentCat ? currentCat : 'all', inputValue],
    queryFn: ({ pageParam }) =>
      menuItemRestuarentService({
        restuarentId: detailId,
        pageParam,
        catParam: currentCat,
        itemParam: itemsPerPage,
        nameParam: inputValue,
      }),
    getNextPageParam: (lastPage: any) => {
      if (lastPage.current_page < lastPage.total_pages) {
        return lastPage.current_page + 1;
      }
      return false;
    },
    initialPageParam: 1,
  });
};
